<template>
    <div>
        <h1>Verify OTP</h1>
        <form @submit.prevent="verifyOtp">
            <div>
                <label for="otp">Одноразовий пароль з смс:</label>
                <input type="text" id="otp" v-model="form.otp" required />
            </div>
            <button type="submit">Відправити</button>
        </form>
    </div>
</template>

<script>
import { Inertia } from '@inertiajs/inertia';

export default {
    data() {
        return {
            form: this.$inertia.form({
                otp: ''
            }),
        }
    },
    methods: {
        verifyOtp() {
            this.form.post('/verify-otp')
        },
    },
};
</script>
